import { BarChart } from "@mui/x-charts";
import { useLanguage } from "../../Translations/LenguageContext";

const BarChartTime = ({
    data,
    loading
}) => {
    const {t} = useLanguage()

    if (loading) {
        return (
            <div className="loading_chart"></div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="empty_chart">
                <p>{t.no_data}</p>
            </div>
        );
    }

    const mcp = data[0];
    const usage = mcp?.usage || {};

    if (!usage || Object.keys(usage).length === 0) {
        return (
            <div className="empty_chart">
                <p>{t.no_data}</p>
            </div>
        );
    }

    const chartDataset = Object.entries(usage)
        .map(([day, values]) => ({
            day,
            success: values["0"] || 0,
            warning: values["1"] || 0,
            error: values["2"] || 0,
        }))
        .sort((a, b) => new Date(a.day) - new Date(b.day));

    return (
        <BarChart
            dataset={chartDataset}
            borderRadius={10}
            xAxis={[
                {
                    dataKey: "day",
                    scaleType: "band",
                    tickLabelStyle: {
                        fill: "var(--originalBlack)"
                    },
                    categoryGapRatio: 0.8,
                }
            ]}

            yAxis={[
                {
                    disableLine: true,
                    disableTicks: true,
                    width: 30,
                    tickLabelStyle: {
                        fill: "var(--originalBlack)"
                    },
                }
            ]}

            series={[
                {
                    dataKey: "success",
                    label: "Success",
                    color: "rgba(3, 105, 240, 0.7)",
                    stack: "total",
                },
                {
                    dataKey: "warning",
                    label: "Warning",
                    color: "rgba(245, 159, 11, 0.7)",
                    stack: "total",
                },
                {
                    dataKey: "error",
                    label: "Error",
                    color: "rgba(245, 11, 11, 0.7)",
                    stack: "total",
                }
            ]}

            grid={{
                vertical: false,
                horizontal: true
            }}

            sx={{
                "& .MuiBarElement-root": {
                    rx: 10,
                    ry: 10,
                }
            }}

            slotProps={{
                legend: { hidden: true },
                axisLine: { hidden: true },
                tooltip: {
                    sx: {
                        backgroundColor: "var(--originalWhite)",
                        border: "1px solid var(--originalLightgray)",
                        borderRadius: "10px",
                        padding: "5px 10px",
                        color: "var(--originalBlack) !important",

                        "& *": {
                            backgroundColor: "transparent !important",
                            border: "1px solid transparent !important",
                            fontSize: "12px !important",
                            color: "var(--originalBlack) !important"
                        },
                    },
                },
            }}
        />
    );
};

export default BarChartTime;